var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreviewCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "open-in-tab"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.99995 16.8C9.55995 16.8 9.18342 16.6435 8.87035 16.3304C8.55675 16.0168 8.39995 15.64 8.39995 15.2V5.6C8.39995 5.16 8.55675 4.7832 8.87035 4.4696C9.18342 4.15653 9.55995 4 9.99995 4H17.2C17.64 4 18.0168 4.15653 18.3304 4.4696C18.6434 4.7832 18.8 5.16 18.8 5.6V15.2C18.8 15.64 18.6434 16.0168 18.3304 16.3304C18.0168 16.6435 17.64 16.8 17.2 16.8H9.99995ZM9.99995 15.2H17.2V5.6H9.99995V15.2ZM6.79995 20C6.35995 20 5.98315 19.8435 5.66955 19.5304C5.35648 19.2168 5.19995 18.84 5.19995 18.4V8C5.19995 7.77333 5.27675 7.5832 5.43035 7.4296C5.58342 7.27653 5.77328 7.2 5.99995 7.2C6.22662 7.2 6.41675 7.27653 6.57035 7.4296C6.72342 7.5832 6.79995 7.77333 6.79995 8V18.4H14.8C15.0266 18.4 15.2168 18.4768 15.3704 18.6304C15.5234 18.7835 15.6 18.9733 15.6 19.2C15.6 19.4267 15.5234 19.6165 15.3704 19.7696C15.2168 19.9232 15.0266 20 14.8 20H6.79995Z",
    fill: "#D6BCFA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewCopy);
export default __webpack_public_path__ + "static/media/PreviewCopy.bad56d03b378d0d9c5c187d452df1a3e.svg";
export { ForwardRef as ReactComponent };